import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [] , error: "", message: "" }


export const userWidthdrawPauseAction = createAsyncThunk(
    'user-widthdraw-pause',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/user-widthdraw-pause?p_user_id=${data?.p_user_id}&publisher_id=${data?.publisher_id}&user_id=${data?.user_id}&is_widthDraw_pause=${data?.is_widthDraw_pause}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const userWidthdrawPauseSlice = createSlice({
    name: 'user-widthdraw-pause',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(userWidthdrawPauseAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(userWidthdrawPauseAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(userWidthdrawPauseAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalCount = action?.payload?.totalCount

            })
        },

})



export const userWidthdrawPauseReducer = userWidthdrawPauseSlice.reducer